module.exports = __webpack_public_path__ + "static/media/solar_panel.aeda0e0a.svg";